import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { deleteDeviation } from '../../../../redux/deviations/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { closeAllCommentThreads } from '../../redux/actions';
var mapStateToProps = function (state, ownProps) { return ({
    isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    showReportModal: showReportModal,
    deleteDeviation: deleteDeviation,
    onPageOpen: closeAllCommentThreads,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CardHeader.container.js.map